export enum SignalType {
  ANALOG = 'analog',
  DIGITAL = 'digital',
}
